export default __webpack_public_path__ + "static/media/Audio.a8340bb1.svg";